import { useParams, useNavigate } from 'react-router-dom';
import { ODataGrid, TitlelessCard, ResponsiveGridColumn, Breakpoints, StatusBadge } from '../../components';
import { GridCellProps, GridRowClickEvent } from '@progress/kendo-react-grid';
import CTEyeService from '../../services/CTEyeService';
import { UrlService } from '../../services';
import { formatDateTime } from '../../app/dateHelpers';
import { router, routes } from '../../app/routes';
import { CTEyeInspectionSummaryModel } from '../../data/entities';

export function CTEyeClientInspectionHistory() {
  const urlParams = useParams();
  const id = UrlService.getParamValue('id', urlParams) ?? '0';
  const navigate = useNavigate();
  const service = new CTEyeService();

  const getData = (oDataQuery: string) => {
    return service.getInspectionSummariesByClient(id, oDataQuery);
  };

  const handleRowClick = (e: GridRowClickEvent) => {
    if (e.dataItem.importInspectionId) {
      navigate(
        router.getUrl(routes.cteyeClientInspectionDetails, new Map([['id', id], ['inspectionId', String(e.dataItem.importInspectionId)]]))
      );
    }
  };

  const dateCell = (field: keyof CTEyeInspectionSummaryModel) => (props: GridCellProps) => {
    const val = props.dataItem[field];
    return <td>{val ? formatDateTime(new Date(val as string)) : '—'}</td>;
  };

  const filePathCell = (props: GridCellProps) => {
    const filePath: string | undefined = props.dataItem.filePath;
    const fileName = filePath ? filePath.split(/[\\/]/).pop() || '—' : '—';
    return <td><code className="small text-break">{fileName}</code></td>;
  };


  const typeCell = (props: GridCellProps) => (
    <td className="d-flex gap-1 flex-wrap">
      {props.dataItem.hasImport && (
        <StatusBadge variant="gray" label="Import" size='sm'/>
      )}
      {props.dataItem.hasLiveView && (
        <StatusBadge variant="green" label="Live" size='sm'/>
      )}
      {props.dataItem.importIsPublished === true && (
        <StatusBadge variant="orange" label="Report" size='sm'/>
      )}
    </td>
  );

  return (
    <div className="row justify-content-center">
      <div className="col-12">
        <div className="mb-3">
          <h5 className="mb-1">Inspection History</h5>
          <p className="text-muted mb-0 small">All inspections associated with this agent</p>
        </div>
        <TitlelessCard className="p-0" bodyClassName="p-0">
          <ODataGrid
            getData={getData}
            onRowClick={handleRowClick}
            pageSize={20}
            pageable={{ buttonCount: 5 }}
            sortable={true}
            filterable={false}
            sort={[{ field: 'startDate', dir: 'desc' }]}
          >
            <ResponsiveGridColumn
              title="File"
              field="filePath"
              sortable={true}
              cell={filePathCell}
            />
            <ResponsiveGridColumn
              title="Date"
              field="startDate"
              sortable={true}
              cell={dateCell('startDate')}
              breakpoint={Breakpoints.sm}
              width={240}
            />
            <ResponsiveGridColumn
              title="Type"
              field="hasImport"
              sortable={false}
              cell={typeCell}
              width={210}
            />
          </ODataGrid>
        </TitlelessCard>
      </div>
    </div>
  );
}

export default CTEyeClientInspectionHistory;
